import { render, staticRenderFns } from "./speedReport.vue?vue&type=template&id=627192b0&scoped=true&"
import script from "./speedReport.vue?vue&type=script&lang=js&"
export * from "./speedReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627192b0",
  null
  
)

export default component.exports